// extracted by mini-css-extract-plugin
export var downArrow = "_90-0";
export var label = "_90-1";
export var treatmentCard = "_90-3";
export var upArrow = "_90-2";